document.addEventListener('DOMContentLoaded', () => {
  const menuBtn = document.querySelector('[data-mobile-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', () => {
      const open = mobileNav.classList.toggle('is-open');
      menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  const subBtn = document.querySelector('[data-mobile-subtoggle]');
  const subNav = document.querySelector('[data-mobile-subnav]');
  if (subBtn && subNav) {
    subBtn.addEventListener('click', () => {
      const open = subNav.classList.toggle('is-open');
      subBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      const mark = subBtn.querySelector('span');
      if (mark) mark.textContent = open ? '−' : '+';
    });
  }

  document.querySelectorAll('[data-dropdown]').forEach((dropdown) => {
    const trigger = dropdown.querySelector('[data-dropdown-trigger]');
    const menu = dropdown.querySelector('[data-dropdown-menu]');
    if (!trigger || !menu) return;
    trigger.addEventListener('click', (event) => {
      if (window.matchMedia('(min-width: 761px)').matches) {
        if (!dropdown.classList.contains('is-open')) {
          event.preventDefault();
          dropdown.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      }
    });
    dropdown.addEventListener('mouseenter', () => {
      if (window.matchMedia('(min-width: 761px)').matches) {
        dropdown.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
    dropdown.addEventListener('mouseleave', () => {
      dropdown.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    });
  });

  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-dropdown].is-open').forEach((dropdown) => {
      if (!dropdown.contains(event.target)) {
        dropdown.classList.remove('is-open');
        const trigger = dropdown.querySelector('[data-dropdown-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      }
    });
  });
});

document.addEventListener('click',function(e){
  var home=document.querySelector('.gp-home-dropdown');
  if(!home)return;
  var trigger=e.target.closest('.gp-home-shop-trigger');
  if(trigger){
    e.preventDefault();
    var isOpen=home.classList.toggle('is-open');
    trigger.setAttribute('aria-expanded',isOpen?'true':'false');
    return;
  }
  if(!e.target.closest('.gp-home-dropdown')){
    home.classList.remove('is-open');
    var t=home.querySelector('.gp-home-shop-trigger');
    if(t)t.setAttribute('aria-expanded','false');
  }
});

/* GOOD PUP homepage quick add: add one bag without leaving the homepage. */
document.addEventListener('submit', async function(event){
  var form = event.target.closest('[data-gp-quickadd]');
  if (!form) return;
  event.preventDefault();
  var button = form.querySelector('button[type="submit"]');
  if (!button || button.disabled) return;
  var original = button.textContent;
  button.disabled = true;
  button.textContent = 'ADDING…';
  try {
    var response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Accept':'application/json'},
      body: new FormData(form)
    });
    if (!response.ok) throw new Error('Add to cart failed');
    form.classList.add('is-added');
    button.textContent = 'ADDED TO BAG ✓';
    setTimeout(function(){
      form.classList.remove('is-added');
      button.textContent = original;
      button.disabled = false;
    }, 1600);
  } catch (err) {
    button.textContent = 'TRY AGAIN';
    setTimeout(function(){ button.textContent = original; button.disabled = false; }, 1600);
  }
});

(function(){var c=document.querySelector('.gp-home-shop-controls');if(!c)return;var b=c.querySelector('.gp-home-flavor-trigger');if(!b)return;b.addEventListener('click',function(e){e.preventDefault();var o=c.classList.toggle('is-open');b.setAttribute('aria-expanded',o?'true':'false');});document.addEventListener('click',function(e){if(!c.contains(e.target)){c.classList.remove('is-open');b.setAttribute('aria-expanded','false');}});})();
